import smile from "assets/images/banners/eyeInternal/smilepro.jpg";
import contoura from "assets/images/banners/eyeInternal/specremoval.jpg";
import catract from "assets/images/banners/eyeInternal/catract.jpg";
import gulcoma from "assets/images/banners/eyeInternal/glaucoma.jpg";
import cornea from "assets/images/banners/eyeInternal/cornea&karetoconous.jpg";
import pedia from "assets/images/banners/eyeInternal/pediatricopthalmology.jpg";
import retina from "assets/images/banners/eyeInternal/retina.jpg";
import oculo from "assets/images/banners/eyeInternal/oculoplastyandcosmaticenhancement.jpg";
import contace from "assets/images/banners/eyeInternal/contactlenses.jpg";
import neuro from "assets/images/banners/eyeInternal/neuroopthamology.jpg";
import lowvision from "assets/images/banners/eyeInternal/lowvisionsyndrome.jpg";

import cataractI from "assets/images/banners/eyeInternalBanner/cataract.png";
import contactLensesI from "assets/images/banners/eyeInternalBanner/contactLens.png";
import contoruaI from "assets/images/banners/eyeInternalBanner/contouraVision.png";
import corneaI from "assets/images/banners/eyeInternalBanner/cornea.png";
import glaucomaI from "assets/images/banners/eyeInternalBanner/glaucoma.png";
import lowvisionI from "assets/images/banners/eyeInternalBanner/lowVision.png";
import neuroI from "assets/images/banners/eyeInternalBanner/neuroOpth.png";
import oculoI from "assets/images/banners/eyeInternalBanner/oculo.png";
import pediaI from "assets/images/banners/eyeInternalBanner/pedia.png";
import retinaI from "assets/images/banners/eyeInternalBanner/retina.png";
import smileProI from "assets/images/banners/eyeInternalBanner/smilePro.png";

export const internalData = [
  {
    id: "smileProSurgery",
    label: "Smile Pro Surgery",
    img: smile,
    banner: smileProI,
    data: [
      {
        header: "What is Smile Pro Surgery",
        content:
          "Smile Pro Surgery is the world’s first robotic flapless and minimally invasive laser vision correction procedure. It uses advanced laser technology to reshape the cornea with unparalleled precision, restoring perfect vision in just 9 seconds.",
        points: null,
      },
      {
        header: "Is Smile Pro Surgery Right for You?",
        content:
          "Ideal for those looking to eliminate the need for glasses or contact lenses, Smile Pro Surgery offers a quick, virtually pain-free solution with a rapid recovery time.",
        points: [
          "Minimal Discomfort: Suitable for those who want a virtually pain-free procedure.",
          "Fast Recovery: Ideal if you want to resume day-to-day activities quickly, usually within 24 hours.",
          "Freedom from Glasses: Great for anyone looking to enjoy a life free from glasses or contact lenses.",
        ],
      },
      {
        header: "How is Smile Pro Surgery Done?",
        content:
          "The Smile Pro Surgery involves making a keyhole incision for lenticule extraction. The precision laser technology reshapes the cornea in just 9 seconds.",
        points: [
          "Minimally Invasive: A tiny keyhole incision of just 3 mm.",
          "High Precision: Advanced laser technology reshapes the cornea.",
        ],
      },
    ],
  },
  {
    id: "contouraVision",
    label: "Contoura Vision - Specs Removal",
    img: contoura,
    banner: contoruaI,
    data: [
      {
        header: "What is Contoura Vision Surgery?",
        content:
          "Contoura Vision is an advanced LASIK procedure that uses computer-guided topographic mapping to correct vision by addressing the microscopic contours of the cornea, providing superior visual acuity and refractive outcomes.",
        points: null,
      },
      {
        header: "Is Contoura Vision Surgery Right for You?",
        content:
          "Perfect for individuals looking to achieve better visual acuity than traditional LASIK, Contoura Vision is recommended for those with irregular corneal curvature and vision issues not adequately addressed by standard procedures.",
        points: [
          "Personalized Treatment: Ideal for those with unique corneal irregularities.",
          "Superior Visual Acuity: Suitable for anyone wanting better results than traditional LASIK.",
          "Customized Procedure: Perfect for individuals needing a highly tailored treatment plan.",
        ],
      },
      {
        header: "How is Contoura Vision Surgery Done?",
        content:
          "Contoura Vision uses a specially designed laser programmed with data from a topographic map of your cornea.",
        points: [
          "Topographic Mapping: Maps at least 22,000 points on your cornea.",
          "Custom Laser Application: Uses a laser designed specifically for your corneal contours.",
          "Precise Corrections: Treats vision irregularities with remarkable precision.",
        ],
      },
    ],
  },
  {
    id: "cataract",
    label: "Cataract",
    img: catract,
    banner: cataractI,
    data: [
      {
        header: "What is Cataract Surgery?",
        content:
          "Cataract surgery is a procedure to remove the cloudy lens of the eye, which is replaced with an artificial lens to restore clear vision. This surgery addresses the common issue of cataracts that typically occur with aging.",
        points: null,
      },
      {
        header: "Is Cataract Surgery Right for You?",
        content:
          "Cataract surgery is recommended for individuals experiencing significant vision impairment due to cataracts, affecting daily activities like reading or driving.",
        points: [
          "Vision Restoration: Ideal for those with blurry or dim vision due to cataracts.",
          "Improved Quality of Life: Suitable for anyone struggling with daily tasks because of poor vision.",
          "Immediate Results: Perfect for those wanting quick improvement in vision clarity.",
        ],
      },
      {
        header: "How is Cataract Surgery Done?",
        content:
          "During cataract surgery, the cloudy lens is carefully removed, often with the assistance of laser technology for precision. The natural lens is then replaced with a clear artificial lens.",
        points: [
          "Lens Removal: The cloudy lens is carefully extracted.",
          "Laser Precision: Advanced laser technology ensures accurate surgery.",
          "Artificial Lens Implant: The natural lens is replaced with a clear, artificial lens.",
          "Quick Recovery: Performed under local anesthesia, allowing swift recovery and immediate vision improvement.",
        ],
      },
    ],
  },
  {
    id: "glaucoma",
    label: "Glaucoma",
    img: gulcoma,
    banner: glaucomaI,
    data: [
      {
        header: "What is Glaucoma?",
        content:
          "Glaucoma is a group of eye conditions that damage the optic nerve, typically due to increased pressure inside the eye, leading to gradual vision loss if untreated.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Gradual Loss of Peripheral Vision",
          "Blurred Vision",
          "Halos around Lights",
          "Severe Eye Pain",
        ],
      },
      {
        header: "Possible Treatments",
        content:
          "Glaucoma can be managed and prevented by the following possible ways:",
        points: [
          "Medication: Prescription eye drops or oral medications to reduce intraocular pressure.",
          "Laser Therapy: Procedures like laser trabeculoplasty to improve fluid drainage.",
          "Surgical Options: Trabeculectomy or minimally invasive glaucoma surgery (MIGS) to create new drainage channels.",
        ],
      },
    ],
  },
  {
    id: "corneaAndKeratoconus",
    label: "Cornea and Keratoconus",
    img: cornea,
    banner: corneaI,
    data: [
      {
        header: "What is Cornea and Keratoconus Care?",
        content:
          "Cornea and Keratoconus Care focuses on specialized treatments for conditions affecting the cornea, such as keratoconus, aimed at improving corneal health and enhancing visual outcomes through advanced therapies and surgical interventions.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Blurry or Distorted Vision",
          "Increased Sensitivity to Light",
          "Difficulty with Night Vision",
          "Frequent Changes in Eyeglass Prescription",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our treatments include:",
        points: [
          "Cross-Linking: Strengthening the cornea with UV light and riboflavin drops.",
          "Intacs: Implantation of small plastic rings to reshape the cornea.",
          "Corneal Transplant: Replacement of the damaged cornea with a healthy donor cornea, tailored to your specific needs.",
        ],
      },
    ],
  },
  {
    id: "pediatricOphthalmology",
    label: "Pediatric Ophthalmology",
    img: pedia,
    banner: pediaI,
    data: [
      {
        header: "What is Pediatric Ophthalmology?",
        content:
          "Pediatric Ophthalmology involves specialized eye care tailored specifically for children, addressing a wide range of vision issues from infancy through adolescence. This field focuses on early detection, diagnosis, and treatment of conditions that can affect visual development, ensuring optimal eye health and function as children grow.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Frequent Squinting or Blinking",
          "Difficulty Reading or Seeing Objects up Close",
          "Poor Hand-Eye Coordination",
          "Inability to Maintain Eye Contact",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our pediatric ophthalmologists provide:",
        points: [
          "Glasses or Contacts: Correcting refractive errors such as nearsightedness or astigmatism.",
          "Vision Therapy: Exercises and activities to improve eye muscle strength and coordination.",
          "Surgical Intervention: Procedures to correct strabismus (crossed eyes) or congenital cataracts, ensuring comprehensive care for young patients.",
        ],
      },
    ],
  },
  {
    id: "retina",
    label: "Retina",
    img: retina,
    banner: retinaI,
    data: [
      {
        header: "What is Retina Ophthalmology?",
        content:
          "Retina care involves the diagnosis, treatment, and management of various conditions affecting the retina, a critical layer of tissue at the back of the eye responsible for converting light into neural signals for vision. This specialized field addresses a range of retinal disorders, such as macular degeneration, diabetic retinopathy, retinal detachment, and more.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Floaters or Spots in Vision",
          "Flashes of Light",
          "Sudden Loss of Vision",
          "Distorted or Wavy Vision",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our retina specialists offer:",
        points: [
          "Intravitreal Injections: Medications injected directly into the eye to treat retinal conditions.",
          "Laser Therapy: Procedures to seal or repair retinal tears or blood vessels.",
          "Vitrectomy: Surgical removal of the vitreous gel to treat severe retinal conditions and ensure comprehensive retinal care.",
        ],
      },
    ],
  },
  {
    id: "oculoplastyAndCosmeticEnhancement",
    label: "Oculoplasty and Cosmetic Enhancement",
    img: oculo,
    banner: oculoI,
    data: [
      {
        header: "What is Oculoplasty and Cosmetic Enhancement?",
        content:
          "Oculoplasty and Cosmetic Enhancement involve surgical procedures focused on the eyelids, tear ducts, and orbit (bony socket around the eye), as well as non-surgical treatments to improve the appearance and function of the eyes and surrounding structures.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Drooping Eyelids",
          "Excessive Tearing",
          "Puffiness or Bags under Eyes",
          "Wrinkles or Fine Lines around Eyes",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our oculoplasty and cosmetic enhancement services include:",
        points: [
          "Blepharoplasty: Surgery to remove excess skin or fat from the eyelids.",
          "Botox Injections: Non-surgical treatment to reduce wrinkles and fine lines.",
          "Tear Duct Surgery: Procedures to clear blocked tear ducts, ensuring both functional and aesthetic improvements.",
        ],
      },
    ],
  },
  {
    id: "contactLenses",
    label: "Contact Lenses",
    img: contace,
    banner: contactLensesI,
    data: [
      {
        header: "What is Contact Lens Care?",
        content:
          "Contact Lens Care involves the fitting, prescription, and maintenance of contact lenses to correct various vision problems such as nearsightedness, farsightedness, astigmatism, and presbyopia. It encompasses a range of lens types and wearing schedules tailored to individual needs.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Discomfort or Irritation",
          "Redness or Swelling",
          "Blurred Vision",
          "Dry Eyes",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our contact lens care services include:",
        points: [
          "Custom Fittings: Personalized fittings for optimal comfort and vision.",
          "Specialty Lenses: Options like multifocal, toric, or rigid gas permeable lenses.",
          "Ongoing Care: Regular check-ups to monitor eye health and lens performance, ensuring comprehensive contact lens management.",
        ],
      },
    ],
  },
  {
    id: "neuroOphthalmology",
    label: "Neuro Ophthalmology",
    img: neuro,
    banner: neuroI,
    data: [
      {
        header: "What is Neuro Ophthalmology?",
        content:
          "Neuro Ophthalmology focuses on the complex relationship between the eyes and the brain, diagnosing and managing visual problems related to the nervous system, including optic nerve disorders, visual field loss, and neurological diseases affecting vision.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Sudden Vision Loss",
          "Double Vision",
          "Visual Field Loss",
          "Eye Movement Disorders",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our neuro ophthalmologists provide:",
        points: [
          "Comprehensive Evaluation: Detailed assessments to identify the underlying neurological causes of visual symptoms.",
          "Medical Management: Treatments for conditions like optic neuritis, myasthenia gravis, and pseudotumor cerebri.",
          "Surgical Interventions: Procedures to address issues such as optic nerve compression or eye movement abnormalities, ensuring integrated care for complex visual disorders.",
        ],
      },
    ],
  },
  {
    id: "lowVisionSyndrome",
    label: "Low Vision Syndrome",
    img: lowvision,
    banner: lowvisionI,
    data: [
      {
        header: "What is Low Vision Syndrome?",
        content:
          "Low Vision Syndrome involves significant visual impairment that cannot be fully corrected with glasses, contact lenses, or surgery, often resulting from conditions such as macular degeneration, glaucoma, diabetic retinopathy, or congenital disorders. This condition affects daily functioning and quality of life.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Difficulty Recognizing Faces",
          "Trouble Reading or Seeing Details",
          "Loss of Central or Peripheral Vision",
          "Struggling with Bright or Low Light Conditions",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our low vision services include:",
        points: [
          "Vision Rehabilitation: Training and tools to maximize remaining vision.",
          "Assistive Devices: Magnifiers, special glasses, and electronic aids.",
          "Adaptive Techniques: Strategies to enhance daily living skills and independence, ensuring comprehensive support for low vision individuals.",
        ],
      },
    ],
  },
];

export const list = [
  {
    id: "smileProSurgery",
    label: "Smile Pro Surgery",
    content: "datamap",
  },
  {
    id: "contouraVision",
    label: "Contoura Vision - Specs Removal",
    content: "datamap",
  },
  {
    id: "cataract",
    label: "Cataract",
    content: "datamap",
  },
  {
    id: "glaucoma",
    label: "Glaucoma",
    content: "datamap",
  },
  {
    id: "corneaAndKeratoconus",
    label: "Cornea and Keratoconus",
    content: "datamap",
  },
  {
    id: "pediatricOphthalmology",
    label: "Pediatric Ophthalmology",
    content: "datamap",
  },
  {
    id: "retina",
    label: "Retina",
    content: "datamap",
  },
  {
    id: "oculoplastyAndCosmeticEnhancement",
    label: "Oculoplasty and Cosmetic Enhancement",
    content: "datamap",
  },
  {
    id: "contactLenses",
    label: "Contact Lenses",
    content: "datamap",
  },
  {
    id: "neuroOphthalmology",
    label: "Neuro Ophthalmology",
    content: "datamap",
  },
  {
    id: "lowVisionSyndrome",
    label: "Low Vision Syndrome",
    content: "datamap",
  },
];

export const listheader = "Our Eye Care specialties";

export const opthomologyInternal = { list, internalData, listheader };
